<template>
    <div class="col s12 vert-offset-top-1">

        <div v-show="component === null || component.length == 0" class="col s12 l10 offset-l1">
            <div class="card grey lighten-4 col s12 padding-top-half flow-text center">
                <h4>Where is your current location?</h4>
                <div class="card-content col s12 left-align">
                    <div class="row vert-offset-bottom-1">
                        <div class="col s12 no-padding">
                            <div class="col s12 m10 offset-m1 padding-top-half padding-bottom-half no-padding flow-text grey-border border-bottom-1 border-lighten-2" >
                                <form @submit.prevent="validate" class="row col s12 no-padding">
                                    <div class="row">
                                        <div class="col s12">
                                            <custom-select-component :options="districts" title="Select District" v-model="selected_district_key" ref="obj_select_district"></custom-select-component>
                                        </div>
                                    </div>
                                    <div class="row" v-if="(selected_district !== null)">
                                        <div class="input-field col s12">
                                            <custom-select-component :options="selected_district.towns.data" title="Select Town" v-model="selected_town_key" ref="obj_select_town"></custom-select-component>
                                        </div>
                                    </div>

                                    <div class="row" v-if="(selected_district !== null && selected_town !==null)">
                                        <div class="input-field col s12">
                                            <input id="locale" type="text" class="validate" v-model="location">
                                            <label for="locale">Where in {{ selected_town.name }}</label>
                                        </div>
                                    </div>


                                </form>
                            </div>
                            <div class="col s4 offset-s8 vert-offset-top-1">
                                <button type="submit" @click="loadTakePicture" class="btn btn-large grey darken-2 white-text col s12" :disabled="location.length <= 0" >
                                    next
                                </button>

                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>

        <component v-bind:is="component"></component>
    </div>
</template>

<script>
 import SelectComponent from "@/components/materialize/SelectComponent.vue";
 import TakePic from "@/components/TakePic"
 import CustomSelectComponent from "./CustomSelectComponent";
 import http from "../http-common"
 export default {

    name:"LocationSelect",
    components:{
        CustomSelectComponent,
        SelectComponent,
        TakePic,

    },
    data () {
        return{
            component:"",
            location:[],
            errors:[],
            districts : [],


            wards:"",
            district:"",
            selected_district_key : "",
            selected_district : null,
            selected_town_key: "",
            selected_town: null,
            selected_district_new: null,
        }
    },
    created(){
        this.getDistricts();
    },
    methods:{

        getDistricts: function() {
            this.$store.dispatch("START_PROCESSING");

            return new Promise(resolve => {
                http({
                    url: "/districts/list/select",
                    data : {

                    },
                    method: "POST",
                    timeout: 30000 })
                    .then(resp => {


                       //console.log("districts:" + JSON.stringify(resp.data));
                        this.districts = resp.data.data;
                        this.$store.dispatch("STOP_PROCESSING");
                        resolve(resp);
                    })
                    .catch(response => {
                       //console.log("ErrResponse: " + JSON.stringify(response));
                        this.$store.dispatch("STOP_PROCESSING");
                        this.$store.dispatch("GET_MESSAGES", response.data.messages);

                    });
            });
        },
        loadTakePicture : function()
        {
            //Validate before proceeding

            this.$store.dispatch('SET_SELECTED_TOWN', this.selected_town.key);
            this.$store.dispatch('SET_SELECTED_DISTRICT', this.selected_district.key);
            this.$store.dispatch('SET_SELECTED_LOCATION', this.location);
            this.component = 'TakePic';
        }
    },
     computed:{
     },
     watch: {
         'selected_district_key' : function(_value)
         {

             this.selected_town_key = null;
             this.selected_ward_key = null;
             this.selected_district = null;
             if(typeof _value !== "undefined" && _value !== null)
             {
                 var _arrFound = this.districts.filter(function(_item)
                 {
                     return (_item.key == _value);
                 });
                 if(_arrFound.length > 0)
                 {
                     this.selected_district = _arrFound[0];
                 }
             }

         },
         'selected_town_key' : function(_value)
         {
             this.selected_ward = null;
             this.selected_town = null;
             if(typeof _value !== "undefined" && _value !== null)
             {

                 /*this.$refs.obj_select_ward.initializeSelect();*/
                 var _arrFound = this.selected_district.towns.data.filter(function(_item)
                 {
                     return (_item.key == _value);
                 });
                 if(_arrFound.length > 0)
                 {
                     this.selected_town = _arrFound[0];
                 }
             }
         },
     }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
